import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s13 flex-right gap-3 mt--2 mb-5 px-5" }
const _hoisted_3 = {
  key: 1,
  class: "btn lg shadow-200 white2 border-none"
}
const _hoisted_4 = {
  key: 0,
  class: "s20 widget flex align-items-center px-1 py-5"
}
const _hoisted_5 = { class: "s2_mobile h-100p px-7" }
const _hoisted_6 = { class: "rounded-100 overflow-hidden item active" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "s3_mobile h-100p px-2" }
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = { class: "s3_mobile h-100p px-2" }
const _hoisted_11 = { class: "font-normal mb-5" }
const _hoisted_12 = { class: "s4_mobile h-100p px-3" }
const _hoisted_13 = { class: "font-normal" }
const _hoisted_14 = { class: "text-2xl" }
const _hoisted_15 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_16 = { class: "widget-floating py-0 text-xl flex-right" }
const _hoisted_17 = {
  key: 0,
  class: "s3_mobile h-100p px-3"
}
const _hoisted_18 = {
  key: 1,
  class: "s20 widget flex align-items-center px-1 py-5"
}

import { calculatePercentage, formatDate, formatDateFrench } from '@/utils';
import { computed, inject, onMounted, provide, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import CollectivitesManagementValidationModal from './CollectivitesManagementValidationModal.vue';
import { useCollectiviteManagementStore } from '@/stores/collectivite-management.store';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesManagement',
  setup(__props) {

const route = useRoute();
const collectiviteManagementStore = useCollectiviteManagementStore();
const BACKEND_URL = inject('BACKEND_URL');
const id = route.params.id;
const menuItems = ref([] as any[]);
const activeMenuItemName = ref('');
const collectivite = ref<any>(route.meta.collectivite || null);
const collectivitesManagementValidationModalRef = ref<InstanceType<typeof CollectivitesManagementValidationModal> | null>(null);
provide('collectivite', collectivite);

onMounted(() => {
    menuItems.value = [
        { url: `/app/collectivites/manage/${id}/infos`, name: 'collectivites-manage-infos', title: 'Informations' },
        { url: `/app/collectivites/manage/${id}/gerant`, name: 'collectivites-manage-gerant', title: 'Gérant' },
        { url: `/app/collectivites/manage/${id}/prospects`, name: 'collectivites-manage-prospects', title: 'Prospects' },
        { url: `/app/collectivites/manage/${id}/membres`, name: 'collectivites-manage-membres', title: 'Membres' },
        { url: `/app/collectivites/manage/${id}/profil-financier`, name: 'collectivites-manage-profil-financier', title: 'Profil financier' },
        { url: `/app/collectivites/manage/${id}/cartes`, name: 'collectivites-manage-cartes', title: 'Cartes' },
        { url: `/app/collectivites/manage/${id}/invitations`, name: 'collectivites-manage-invitations', title: 'Invitations' },
    ];
    if (route.name) { listenRouteChanges(route.name.toString()); }
});

watch(() => route.name, (newRouteName) => {
    if (newRouteName) { listenRouteChanges(newRouteName.toString()); }
});

watch(() => collectiviteManagementStore.reloadVersion, () => {
    fetchCollectivite();
});

async function fetchCollectivite() {
    const res = await axios.get(`/backoffice/collectivites/get/${collectivite.value.id}`);
    collectivite.value = res.data;
}

function listenRouteChanges(newRouteName: string) {
    activeMenuItemName.value = newRouteName.toString();
}

const stats = computed(() => collectivite.value.stats || {});

const membersPercentage = computed(() => {
    const maxMembers = stats.value.total_users_count || 0; // Valeur par défaut pour la barre de progression
    if (maxMembers === 0) { return 0; }

    return Math.min(100, calculatePercentage(stats.value.members_count, maxMembers));
});

async function validateCollectivite() {
    const res = await collectivitesManagementValidationModalRef.value?.open(collectivite.value.id);
    if (res) {
        collectiviteManagementStore.notifyReload();
    }
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "page-space-40" }, null, -1)),
    _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "s7 font-semibold px-3 pb-5" }, [
      _createTextVNode("Collectivité "),
      _createElementVNode("span", { class: "text-sm text-grey-500" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (collectivite.value)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(menuItems.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              to: item.url,
              key: index
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass(["btn lg shadow-200", {'white2 border-none': item.name == activeMenuItemName.value, 'light2': item.name != activeMenuItemName.value}])
                }, _toDisplayString(item.title), 3)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, "Enregistrement de collectivité"))
    ]),
    (collectivite.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: collectivite.value.logo ? (_unref(BACKEND_URL) + '/assets/collectivites/' + collectivite.value.logo) : '/assets/logos/logo2.svg',
                width: "100%"
              }, null, 8, _hoisted_7)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h4", _hoisted_9, _toDisplayString(collectivite.value.nom || ''), 1),
            _createElementVNode("h3", null, _toDisplayString(collectivite.value.rccm || 'N/A'), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h4", _hoisted_11, _toDisplayString((stats.value.members_count || 0) + ' / ' + (stats.value.total_users_count || 0)) + " Membres", 1),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "tag-state warning stroke" }, "En cours", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "tag-state notif stroke" }, "Actif", -1))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h4", _hoisted_13, [
              _cache[2] || (_cache[2] = _createTextVNode(" Date de création ", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
              _createElementVNode("b", _hoisted_14, _toDisplayString(_unref(formatDateFrench)(collectivite.value.created_at)), 1)
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["s5_mobile h-100p px-5", {'s5_mobile': !collectivite.value.verrouille, 's8_mobile': collectivite.value.verrouille}])
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, "Membres " + _toDisplayString(stats.value.members_count ? Math.round((stats.value.members_count / stats.value.total_users_count) * 100) : 0) + "%", 1),
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green",
                style: _normalizeStyle({ width: membersPercentage.value + '%' })
              }, _toDisplayString((stats.value.members_count || 0) + ' / ' + (stats.value.total_users_count || 0)), 5)
            ])
          ], 2),
          (!collectivite.value.verrouille)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_custom_button, {
                  type: "button",
                  classesList: 'btn-ultra w-100 lg',
                  onClick: validateCollectivite
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("img", {
                      src: "/icons/icon-valider.svg",
                      class: "btn-icon",
                      alt: ""
                    }, null, -1),
                    _createElementVNode("span", null, "Valider le dossier", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[5] || (_cache[5] = [
          _createStaticVNode("<div class=\"s2_mobile h-100p px-7\"><div class=\"rounded-100 overflow-hidden item active\"><img src=\"/assets/logos/logo2.svg\" width=\"100%\"></div></div><div class=\"s18_mobile h-100p px-2\"><h4 class=\"mb-2\">Nouvelle collectivité</h4><h5>Saisir les informations de la collectivité</h5></div>", 2)
        ]))])),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    _createVNode(_component_router_view),
    _createVNode(CollectivitesManagementValidationModal, {
      ref_key: "collectivitesManagementValidationModalRef",
      ref: collectivitesManagementValidationModalRef
    }, null, 512)
  ]))
}
}

})